import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-move_line",
  "use": "vab-icon-move_line-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-move_line\">\n<path d=\"M20 15C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17H4C3.44772 17 3 16.5523 3 16C3 15.4477 3.44772 15 4 15H20ZM20 8C20.5523 8 21 8.44772 21 9C21 9.55228 20.5523 10 20 10H4C3.44772 10 3 9.55228 3 9C3 8.44772 3.44772 8 4 8H20Z\" fill=\"#bababa\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol